import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html'
})
export class DocumentDownloadComponent implements OnInit {
  fileUrl: string = '';  // Initialize fileUrl

  constructor(
    private route: ActivatedRoute,
    private router: Router,   // Inject Router to handle redirection
    private http: HttpClient  // Inject HttpClient to check file existence
  ) {}

  ngOnInit(): void {
    const fileName = this.route.snapshot.paramMap.get('fileName');

    if (fileName) {
      // Construct the full file URL
      this.fileUrl = `https://s3://hhi-mfdev-consumerportal-website-bucket/assets/guide/documents/${fileName}`;
      
      // Check if the file exists before proceeding
      this.checkFileExists(this.fileUrl).subscribe(
        (exists) => {
          if (exists) {
            // If file exists, initiate the download
            this.downloadFile(this.fileUrl);
          } else {
            // If file does not exist, redirect to wildcard route (404 or any fallback page)
            this.router.navigate(['/not-found']); // Replace with your desired route
          }
        },
        (error) => {
          // If there’s an error while checking, redirect to the wildcard route
          console.error('Error checking file existence', error);
          this.router.navigate(['/not-found']); // Redirect to a fallback route
        }
      );
    } else {
      // If fileName is missing, redirect to wildcard route (404 or any fallback page)
      this.router.navigate(['/not-found']); // Replace with your desired route
    }
  }

  // Method to check if the file exists on the server or S3
  checkFileExists(url: string) {
    return this.http.head(url, { observe: 'response' }).pipe(
      map(response => response.status === 200),  // If status is 200, file exists
      catchError(() => of(false))  // If error occurs (file not found), return false
    );
  }

  // Method to trigger file download
  downloadFile(url: string): void {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';  // Open in a new tab or download
    const fileName = url.split('/').pop() || 'download';  // Extract file name from URL
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
